export default __webpack_public_path__ + "static/media/scaleGifts.575980b3.png";